import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import * as fromJobs from '../../jobs-module/reducers';
import { Store } from '@ngrx/store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mj-job-sourcing-page',
  template: `
    <div
      style="margin-top: 3em"
      fxFlex
      fxLayout="row"
      fxLayoutAlign="center"
      fxLayoutGap="3em"
    >
      <div fxFlex="45">
        <mj-job-boards [jobState]="jobState$ | async"> </mj-job-boards>
      </div>
      <div fxFlex="35">
        <mj-job-social-media-preview [jobState]="jobState$ | async">
        </mj-job-social-media-preview>
      </div>
    </div>
  `,
  styleUrls: ['./job-sourcing-page.style.scss'],
})
export class JobSourcingPageComponent implements OnInit {
  jobState$: any;

  constructor(private jobStore: Store<fromJobs.State>) {}

  ngOnInit(): void {
    this.jobState$ = this.jobStore.select(fromJobs.getSelectedJob);
  }
}
